import { Link } from 'react-router'
import classNames from 'classnames'
import { Icon } from 'shared/ui/Icon'
import { Typography } from 'shared/ui/Typography'
import styles from './styles.module.scss'

type IBreadcrumbsUiProps = {
  path: string
  storyData?: string
  label?: string
  className?: string
}

export const BreadcrumbsUi = ({ path, storyData, label, className }: IBreadcrumbsUiProps) => {
  return (
    <div className={classNames(styles.wrap, className)}>
      {storyData && (
        <Typography variant={'body-sm-regular'} pointer className={styles.link} ariaLabel={'story'}>
          {storyData}
        </Typography>
      )}
      <Link to={path} className={styles.link}>
        <Icon icon={'chevronLeft'} />
        <Typography variant={'body-sm-regular'} pointer ariaLabel={'Back'}>
          Back to {label}
        </Typography>
      </Link>
    </div>
  )
}
